import { useMemo } from 'react';

import type { JourneySocketData } from '@/types';

import useSocketSubscription from '@/hooks/use-socket-subscription';
// TODO: add enhancement for a finding active journey by passing journeyId as a props
const useGetRoutesDeviationMap = () => {
  const { data: socketData, isLoading } =
    useSocketSubscription<JourneySocketData>('active_journeys_for_map');

  const activeJourneys = socketData?.journeys;

  const deviationMap = useMemo(() => {
    const list = activeJourneys ?? [];

    return list.reduce(
      (acc, item) => {
        acc[item.id] = item.deviation;

        return acc;
      },
      {} as Record<string, number>
    );
  }, [socketData]);

  return {
    deviationMap,
    activeJourneyIds: socketData?.activeJourneyIds,
    isLoading,
    activeJourneys,
  };
};

export default useGetRoutesDeviationMap;
